import { render } from "./OtherDeviceApproval.vue?vue&type=template&id=641759e0&ts=true"
import script from "./OtherDeviceApproval.vue?vue&type=script&lang=ts"
export * from "./OtherDeviceApproval.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress});
